var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 7,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6 16v18c0 .552.448 1 1 1s1-.448 1-1v-18c0-.552-.448-1-1-1s-1 .448-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61 26c.552 0 1-.448 1-1v-18c0-.552-.448-1-1-1h-48c-.552 0-1 .448-1 1v3h-8v-6h47c.552 0 1-.448 1-1s-.448-1-1-1h-48c-.552 0-1 .448-1 1v36c0 .552.448 1 1 1h9v3c0 .552.448 1 1 1h43v1c0 1.654-1.346 3-3 3h-42c-1.654 0-3-1.346-3-3v-2c0-.552-.448-1-1-1s-1 .448-1 1v2c0 2.757 2.243 5 5 5h10.934c-.307 2.35-1.679 4.481-3.736 5.715l-.475.285h-2.723c-2.757 0-5 2.243-5 5 0 .552.448 1 1 1h30c.552 0 1-.448 1-1s-.448-1-1-1h-28.829c.413-1.164 1.525-2 2.829-2h34c1.304 0 2.416.836 2.829 2h-6.829c-.552 0-1 .448-1 1s.448 1 1 1h8c.552 0 1-.448 1-1 0-2.757-2.243-5-5-5h-2.723l-.475-.285c-2.056-1.234-3.429-3.365-3.736-5.715h10.934c2.757 0 5-2.243 5-5v-1h3c.552 0 1-.448 1-1v-14c0-.552-.448-1-1-1s-1 .448-1 1v13h-46v-19c0-.552-.448-1-1-1s-1 .448-1 1v15h-8v-26h8v7c0 .552.448 1 1 1s1-.448 1-1v-3h43c.552 0 1-.448 1-1s-.448-1-1-1h-43v-6h46v17c0 .552.448 1 1 1zm-18.067 30h-21.866c1.612-1.596 2.645-3.724 2.881-6h16.104c.236 2.276 1.269 4.404 2.881 6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 10c-.552 0-1 .448-1 1s.448 1 1 1h27c.552 0 1-.448 1-1s-.448-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 39h6c.552 0 1-.448 1-1v-5h5c.552 0 1-.448 1-1v-6c0-.552-.448-1-1-1h-5v-5c0-.552-.448-1-1-1h-6c-.552 0-1 .448-1 1v5h-5c-.552 0-1 .448-1 1v6c0 .552.448 1 1 1h5v5c0 .552.448 1 1 1zm-5-8v-4h5c.552 0 1-.448 1-1v-5h4v5c0 .552.448 1 1 1h5v4h-5c-.552 0-1 .448-1 1v5h-4v-5c0-.552-.448-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 20h-13c-.552 0-1 .448-1 1s.448 1 1 1h13c.552 0 1-.448 1-1s-.448-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 24h-16c-.552 0-1 .448-1 1s.448 1 1 1h16c.552 0 1-.448 1-1s-.448-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 28h-16c-.552 0-1 .448-1 1s.448 1 1 1h16c.552 0 1-.448 1-1s-.448-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 32h-16c-.552 0-1 .448-1 1s.448 1 1 1h16c.552 0 1-.448 1-1s-.448-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56 36h-16c-.552 0-1 .448-1 1s.448 1 1 1h16c.552 0 1-.448 1-1s-.448-1-1-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/health.f84d256eba03776ee7886072c4214c61.svg";
export { ForwardRef as ReactComponent };